<template>
  <chart-card title="Cupons" filter-button :filter-type.sync="filterType" :data="chartData" :chart-loading="loading" is-integer />
</template>

<script>
import ChartCard from '@/components/ChartCard.vue'
import { mapState } from 'vuex'
import { mapWaitingActions } from 'vue-wait'
import * as helpers from '@/config/helpers.js'
import { colors } from '@/config/colors.js'

export default {
  components: {
    ChartCard,
  },
  data: () => ({
    filterType: 'mensal',
    listaCuponsMensal: [],
    listaCuponsSemanal: [],
    listaCuponsDiario: [],
    loading: true,
  }),
  computed: {
    ...mapState({
      stateFilters: (state) => state.filters,
    }),
    filtro() {
      return {
        unidades: this.stateFilters.unitsConfiguration,
        segmentos: this.stateFilters.segments,
      }
    },
    cupons() {
      if (this.filterType === 'mensal') return this.cuponsMensal
      if (this.filterType === 'semanal') return this.cuponsSemanal
      if (this.filterType === 'diario') return this.cuponsDiario
      return ''
    },
    cuponsMensal() {
      return helpers.agrupamentoMensal(this.listaCuponsMensal, 'NUM_CUPONS')
    },
    cuponsSemanal() {
      return helpers.agrupamentoSemanal(this.listaCuponsSemanal, 'NUM_CUPONS')
    },
    cuponsDiario() {
      return helpers.agrupamentoDiario(this.listaCuponsDiario, 'NUM_CUPONS')
    },
    chartData() {
      return {
        labels: [...this.cupons.map((object) => object.data)],
        datasets: [
          {
            label: 'Cupons',
            backgroundColor: colors[0],
            strokeColor: colors[0],
            borderColor: colors[0],
            data: [...this.cupons.map((object) => object.valor)],
            fill: false,
          },
        ],
      }
    },
  },
  watch: {
    filterType() {
      this.getData()
    },
  },
  async mounted() {
    this.$bus.$on('filter', this.getData)

    this.$nextTick(async () => {
      await this.getData()
    })
  },
  destroyed() {
    this.$bus.$off('filter')
  },
  methods: {
    ...mapWaitingActions({
      empresaCupons: 'cupons',
    }),
    async getData() {
      try {
        this.loading = true
        if (this.filterType === 'mensal') {
          await this.empresaCupons({ group_field: 'ano,mes', ...this.filtro }).then((data) => {
            this.listaCuponsMensal = data
          })
        } else if (this.filterType === 'semanal') {
          await this.empresaCupons({ group_field: 'ano,semana', ...this.filtro }).then((data) => {
            this.listaCuponsSemanal = data
          })
        } else if (this.filterType === 'diario') {
          await this.empresaCupons({ group_field: 'anomesdia', ...this.filtro }).then((data) => {
            this.listaCuponsDiario = data
          })
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
